import { action } from 'typesafe-actions';

import { IOkved } from 'APIPackage/KnmModule/interfaces/IOkved';

import { RegistryActionsEnum } from '../enums/RegistryActionsEnum';
import { IRegistryExportOkvedFilterParams } from '../interfaces/IRegistryExportOkvedFilterParams';

export const registryExportOkvedGet = (filterParams: IRegistryExportOkvedFilterParams) =>
  action(RegistryActionsEnum.REGISTRY_EXPORT_OKVED_GET, { filterParams });
export const registryExportOkvedGetRequest = (filterParams: IRegistryExportOkvedFilterParams) =>
  action(RegistryActionsEnum.REGISTRY_EXPORT_OKVED_GET_REQUEST, { filterParams });
export const registryExportOkvedGetSuccess = (filterParams: IRegistryExportOkvedFilterParams, data: IOkved[]) =>
  action(RegistryActionsEnum.REGISTRY_EXPORT_OKVED_GET_SUCCESS, { filterParams, data });
export const registryExportOkvedGetFailure = (filterParams: IRegistryExportOkvedFilterParams) =>
  action(RegistryActionsEnum.REGISTRY_EXPORT_OKVED_GET_FAILURE, { filterParams });
